export interface TimelineEvent {
  id: string;
  rechnung_id: string;
  typ: TimelineEventType;
  inhalt: string | null;
  user_id: string | null;
  ziel_user_id: string | null;
  created_at: string;
  user?: { full_name: string } | null;
  ziel_user?: { full_name: string } | null;
}

export type TimelineEventType =
  | 'kommentar'
  | 'zuweisung'
  | 'tech_pruefung_angefordert'
  | 'tech_pruefung_ergebnis'
  | 'freigabe_angefordert'
  | 'freigabe_ergebnis'
  | 'status_aenderung'
  | 'bezahlung'
  | 'et_weitergeleitet'
  | 'korrektur_angefordert'
  // Eigene Typen, weil der Verlauf sonst in sich widerspruechlich waere: eine zurueckgezogene Anfrage und eine
  // zugeordnete Nachfolgerin sind gerade NICHT „Korrektur angefordert".
  | 'korrektur_zurueckgezogen'
  | 'korrektur_verknuepft';

export type TechPruefungStatus = 'angefordert' | 'freigegeben' | 'abgelehnt' | null;

export type RechnungenBereich = 'weg' | 'mv' | 'alle' | null;

export interface WorkflowState {
  kannBezahlen: boolean;
  brauchtFreigabe: boolean;
  istFreigegeben: boolean;
  hatTechPruefung: boolean;
  techPruefungLaeuft: boolean;
}

export const TIMELINE_CONFIG: Record<TimelineEventType, { icon: string; color: string; label: string }> = {
  kommentar: { icon: '💬', color: '#6b7280', label: 'Kommentar' },
  zuweisung: { icon: '👤', color: '#f59e0b', label: 'Zuweisung' },
  tech_pruefung_angefordert: { icon: '🔧', color: '#a855f7', label: 'Sachl. & rechn. Prüfung' },
  tech_pruefung_ergebnis: { icon: '✅', color: '#22c55e', label: 'Prüfungsergebnis' },
  freigabe_angefordert: { icon: '👁️', color: '#ef4444', label: 'Freigabe angefordert' },
  freigabe_ergebnis: { icon: '✅', color: '#22c55e', label: 'Freigabe erteilt' },
  status_aenderung: { icon: '📋', color: '#3b82f6', label: 'Status geändert' },
  bezahlung: { icon: '💰', color: '#c4a77d', label: 'Bezahlt' },
  et_weitergeleitet: { icon: '📤', color: '#6366f1', label: 'An ET weitergeleitet' },
  korrektur_angefordert: { icon: '↩️', color: '#0ea5e9', label: 'Korrektur angefordert' },
  korrektur_zurueckgezogen: { icon: '↩️', color: '#9ca3af', label: 'Korrekturanfrage zurückgezogen' },
  korrektur_verknuepft: { icon: '🔗', color: '#0ea5e9', label: 'Korrektur zugeordnet' },
};
